module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_6005.da62d4a0.png";